
export const COLORS = {
  primary: "#1e40af",
  primaryHover: "#1e3a8a",
  primaryLight: "#eff6ff",
  success: "#10b981",
  error: "#ef4444",
  errorHover: "#dc2626",
  errorLight: "#fef2f2",
  border: "#e5e7eb",
  textPrimary: "#111827",
  textSecondary: "#6b7280",
  background: "#f3f4f6",
  white: "#fff",
  // Appointment Card colors (Medarch-DS standardized)
  doctorInfoBg: "#F2F6F8",
  providerName: "#373D41",
  providerRole: "#74797B",
  detailLabel: "#595F63",
  cancel: "#B1000F",
  cancelBg: "#FFF2F3",
  cancelHover: "#ffe5e7",
  reschedule: "#104E84",
  rescheduleBg: "#EEF7FF",
  rescheduleHover: "#dceefb",
  joinVisit: "#104E84",
  joinVisitHover: "#0D3E6A",
  // Action item button
  actionButtonBg: "#EEF7FF",
  actionButtonColor: "#104E84",
} as const;

export const APPOINTMENT_MODE_COLORS: Record<
  string,
  { color: string; bgColor: string; label: string }
> = {
  VIRTUAL: { color: "#7048C2", bgColor: "#F3EEFF", label: "Telehealth" },
  IN_PERSON: { color: "#3C7BD3", bgColor: "#E0EDFF", label: "In-Person" },
} as const;

export const APPOINTMENT_STATUS_MAPPER: Record<string, string> = {
  CONFIRMED: "Confirmed",
  SCHEDULED: "Scheduled",
  CANCELLED: "Cancelled",
  PENDING: "Pending",
  CHECKED_IN: "Checked In",
} as const;

export const APPOINTMENT_STATUS_STYLE: Record<
  string,
  { color: string; bgColor: string }
> = {
  CONFIRMED: { color: "#00B917", bgColor: "#E8F5E9" },
  SCHEDULED: { color: "#417DE0", bgColor: "#DCE6F7" },
  CANCELLED: { color: "#FF3939", bgColor: "#FFE1E0" },
  PENDING: { color: "#f59e0b", bgColor: "#FEF3C7" },
  CHECKED_IN: { color: "#7048C2", bgColor: "#F3EEFF" },
} as const;

export const BADGE_COLORS = {
  success: { color: COLORS.success },
  error: { color: COLORS.error },
  warning: { color: "#f59e0b" },
  info: { color: "#417DE0" },
} as const;

export const CARD_STYLES = {
  border: `1px solid ${COLORS.border}`,
  borderRadius: "8px",
  marginBottom: 2,
  backgroundColor: COLORS.white,
  hover: { boxShadow: "0 2px 8px rgba(0,0,0,0.1)" },
} as const;

export const BUTTON_STYLES = {
  outlined: {
    borderColor: COLORS.primary,
    color: COLORS.primary,
    textTransform: "none" as const,
    fontSize: "14px",
    "&:hover": {
      borderColor: COLORS.primaryHover,
      backgroundColor: COLORS.primaryLight,
    },
  },
  outlinedError: {
    borderColor: COLORS.error,
    color: COLORS.error,
    textTransform: "none" as const,
    fontSize: "14px",
    "&:hover": {
      borderColor: COLORS.errorHover,
      backgroundColor: COLORS.errorLight,
    },
  },
  contained: {
    backgroundColor: COLORS.primary,
    textTransform: "none" as const,
    fontSize: "14px",
    "&:hover": { backgroundColor: COLORS.primaryHover },
  },
} as const;


